<template>
	<div class="input-group-prepend aggregate" @mouseover="aggregateBtn = true" @mouseleave="aggregateBtn = false">
		<div v-if="aggregateBtn && column.aggregates.length > 0" ref="dropdown">
			<!-- Dropdown Button -->
			<button class="btn btn-sm aggregates-button" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ref="filterButton" data-offset="-2">
				<icon icon="long-arrow-up" />
			</button>

			<div class="dropdown-menu py-0" aria-labelledby="dropdownMenuButton" ref="dropdownItems">
				<a class="dropdown-item py-0" v-for="(agg, index) of column.aggregates" :key="index" @click="aggregateSelected($event, agg)">
					{{ String(agg.title) }}
				</a>
			</div>
		</div>
		<div class="aggregate mr-1" :title="column.aggregates[0].title" v-if="column.aggregates[0] && aggregateSelect == null && column.aggregates.findIndex(x => !x.isSystem) > -1">
			<div>
				<span class="label" v-if="!column.aggregates[0].hideTitle">
					{{ String(column.aggregates[0].title) }}
				</span>
				<span class="value" style="display: inline-block" v-html="String(column.aggregates[0].value)"></span>
			</div>
			<div v-if="column.aggregates[0].valueForSelecteds">
				<span class="label" v-if="!column.aggregates[0].hideTitle">
					{{ $t('table.aggregates.selected') }}
				</span>
				<span class="value" style="display: inline-block" v-html="String(column.aggregates[0].valueForSelecteds)"></span>
			</div>
		</div>

		<div class="aggregate mr-1" :title="aggregateSelect.title" v-if="aggregateSelect != null">
			<div>
				<span class="label">
					{{ String(aggregateSelect.title) }}
				</span>
				<span class="value" style="display: inline-block" v-html="String(aggregateSelect.value)"></span>
			</div>
			<div v-if="aggregateSelect.valueForSelecteds">
				<span class="label">
					{{ $t('table.aggregates.selected') }}
				</span>
				<span class="value" style="display: inline-block" v-html="String(aggregateSelect.valueForSelecteds)"></span>
			</div>
		</div>
	</div>
</template>

<script>
	import _ from 'lodash'
	import { i18nInstance } from '~/plugins/localization'

	const translator = i18nInstance.global.t

	export default {
		name: 'Aggregates',

		// Props
		props: {
			column: {
				type: Object,
				default() {
					return {}
				}
			},

			filteredData: {
				type: Object,
				defaut() {
					return {}
				}
			},

			selectedData: {
				type: Array,
				defaut() {
					return []
				}
			}
		},

		emits: ['aggregate-selected'],

		// Data
		data() {
			return {
				aggregateBtn: false,
				aggregateSelect: null,
				called: false
			}
		},

		// Mounted
		mounted() {

		},

		// Updated
		updated() {
			if (!this.called) {
				this.$emit('aggregate-selected')
				this.called = true
			}
		},

		// Methods
		methods: {
			aggregateSelected(event, aggregate) {
				this.aggregateSelect = aggregate
				this.column.aggregates.forEach((agg) => {
					agg.visible = false
				})
				this.aggregateSelect.visible = true
				this.$emit('aggregate-selected')
			},

			setDefaultAggregates() {
				// if (this.column.type === 'number' || this.column.type === 'price' || this.column.type === 'string') {
				if (
					this.filteredData == null ||
					Object.keys(this.filteredData).length === 0 ||
					typeof this.filteredData[this.column.name] !== 'object'
				) {
					var merged = _.extend(
						_.keyBy(this.defaultNumberAggregates(), 'type'),
						_.keyBy(this.column.aggregates, 'type')
					)
					for (let item in merged) {
						if (merged[item].handler)
							continue
						let defaults = _.keyBy(this.defaultNumberAggregates(), 'type')
						if (defaults[item]) {
							merged[item] = _.merge(defaults[item], merged[item])
						}
					}
					this.column.aggregates = _.values(merged)
				}
				// }
			},

			defaultNumberAggregates() {
				return [
					{
						title: translator('row-count'),
						type: 'count',
						isSystem: true,
						visible: true,
						order: 10,
						handler: (data, col) => {
							return (
								'<div class="font-weight-bold">' + ': ' + (data || []).length + '</div>'
							)
						}
					},
					{
						title: translator('table.aggregates.sum'),
						type: 'sum',
						order: 15,
						isSystem: true,
						visible: true,
						handler: (data, col) => {
							if (this.aggregateSelect == null) {
								return '<div class="font-weight-bold"></div>'
							} else if (this.aggregateSelect.type === 'sum' || (this.column.aggregates && this.column.aggregates[0].type === 'sum')) {
								let sum = 0
								if (data.length > 0) {
									sum = _.sumBy(data, (x) => {
										return Number(_.get(x, col.name))
									})
									sum = Number.isNaN(sum) ? '' : sum // prevent NaN
									if (col.type == 'price')
										sum = sum.toString().toPriceFormat()
								}
								return ('<div class="font-weight-bold">' + ': ' + sum + '</div>')
							}
						}
					},
					{
						title: translator('table.aggregates.max'),
						type: 'max',
						order: 20,
						isSystem: true,
						visible: true,
						handler: (data, col) => {
							if (this.aggregateSelect == null) {
								return '<div class="font-weight-bold"></div>'
							} else if (this.aggregateSelect.type === 'max' || (this.column.aggregates && this.column.aggregates[0].type === 'max')) {
								let max = ''
								if (data.length > 0) {
									let temp = _.maxBy(data, (x) => {
										return Number(_.get(x, col.name))
									})
									max = temp ? _.get(temp, col.name) : ''
									if (col.type == 'price')
										max = max.toString().toPriceFormat()
								}
								return ('<div class="font-weight-bold">' + ': ' + max + '</div>')
							}
						}
					},
					{
						title: translator('table.aggregates.min'),
						type: 'min',
						order: 30,
						isSystem: true,
						visible: true,
						handler: (data, col) => {
							if (this.aggregateSelect == null) {
								return '<div class="font-weight-bold"></div>'
							} else if (this.aggregateSelect.type === 'min' || (this.column.aggregates && this.column.aggregates[0].type === 'min')) {
								let min = ''
								if (data.length > 0) {
									let temp = _.minBy(data, (x) => {
										return Number(_.get(x, col.name))
									})
									min = temp ? _.get(temp, col.name) : ''
									if (col.type == 'price')
										min = min.toString().toPriceFormat()
								}
								return ('<div class="font-weight-bold">' + ': ' + min + '</div>')
							}
						}
					}
				]
			}
		}
	}
</script>

<style>
	.input-group-prepend.aggregate {
		min-height: 30px;
		white-space: pre;
	}

	.aggregates-button {
		position: absolute !important;
		left: 0;
		bottom: 0;
		animation-name: aggregates-button;
		animation-duration: 0.2s;
	}

	@keyframes aggregates-button {
		from {
			margin-left: -5px;
		}

		to {
			margin-left: 0;
		}
	}
</style>
